import React, {useState, useEffect} from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Tmdb from '../../lib/Tmdb';
import {Grid,Skeleton, Pagination, Stack} from '@mui/material';
import { styled } from "@mui/material/styles";
import MovieCard from '../../components/MovieRow/MovieCard';
import FeaturedItem from '../../components/FeaturedItem/FeaturedItem';


const FullCategory = ()=>{
    let { category } = useParams();
    let type = (category == "originals") ? 'tv' : 'movie';
    const [categoryItems, setCategoryItems] = useState(null);
    const [featuredMovieItem, setFeaturedMovieItem] = useState(null);
    const [currentPageNumber, setCurrentPageNumber] = useState('1')
    const changePage = (event)=>{
        setCurrentPageNumber(event.target.outerText)

      }
    useEffect(()=>{
        const loadAll = async () =>{
        window.scrollTo(0, 310)
          let listOfItems = await Tmdb.getHomelist(category,currentPageNumber);
          setCategoryItems(listOfItems)
          let featured = listOfItems.items.results[Math.floor(Math.random()*(listOfItems.items.results.length-1))]
          let detailedFeatured = await Tmdb.getAditionalInfo(featured.id, type)
          setFeaturedMovieItem(detailedFeatured)

        }
        loadAll();
      },[currentPageNumber]);

    return(
       <>
       {featuredMovieItem != null?
        <FeaturedItem item={featuredMovieItem} currentView={'home'}/>
        :
        <div style={{height:"85vh",width:"100%", display:"grid", flexWrap:"wrap", alignContent:"center",}}>
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"8px", marginLeft:"3rem" }} variant="rect" width={'60%'} height={'3.75rem'} />
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"3px", marginLeft:"3rem", marginTop:"4%" }} variant="rect" width={'35%'} height={'1.2rem'} />
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"8px", marginLeft:"3rem", marginTop:"1rem" }} variant="rect" width={'45%'} height={'6rem'} />
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"3px", marginLeft:"3rem", marginTop:"1rem" }} variant="rect" width={'25%'} height={'1.2rem'} />
      </div>
        }
         <Grid container sx={{paddingBottom:"7vh"}}>
            {categoryItems != null ?
            <>
            <Grid container paddingBottom={2} sx={{display:"block", marginTop:"-3rem"}} >
            <h2 className='title'>{categoryItems.title} </h2>
             </Grid>
                {categoryItems.items.results.map((item,key)=>(
                    <Grid item xs={6} md={3} lg={2} key={key}><MovieCard item={item}/></Grid>
                ))}
                 <Grid container justifyContent="center" paddingBottom={2} paddingTop={4}>
               <Stack spacing={2}>
                <Pagination color='error' onClick={event => changePage(event)} count={20} hidePrevButton hideNextButton/>
                </Stack>
               </Grid>
            </>
            :
            <></>
            }
              
        </Grid>
       </>
    );
}
export default FullCategory;